import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/AutonomousMaintenanceOrderTasksActions";
import * as api from "../../api/autonomousMaintenanceOrderTasksApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import moment from "moment";

function* getTaskList(action) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.getTaskList(action.payload);
    yield put(actions.setTaskList(data || undefined));
    yield put(actions.resetTaskList());
  } catch (error) {
    // yield put(actions.setTaskList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getStatusList(action) {
  try {
    const { data } = yield api.getStatusList(action.payload);
    yield put(actions.setStatusList(data || undefined));
    yield put(actions.resetStatusList());
  } catch (error) {
    yield put(actions.setStatusList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getAreaList() {
  try {
    const { data } = yield api.getAreaList();
    yield put(actions.setAreaListAutonomous(data || undefined));
    yield put(actions.resetAreaListAutonomous());
  } catch (error) {
    yield put(actions.setAreaListAutonomous(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getTechnicianList() {
  try {
    const { data } = yield api.getTechnicianList();
    yield put(actions.setTechnicianList(data || undefined));
    yield put(actions.resetTechnicianList(data || undefined));
  } catch (error) {
    yield put(actions.setTechnicianList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getCostCenterList() {
  try {
    const { data } = yield api.getCostCenterList();
    yield put(actions.setCostCenterList(data || undefined));
    yield put(actions.resetCostCenterList());
  } catch (error) {
    yield put(actions.setCostCenterList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getMainListByAreaIDAutonomous(action) {
  try {
    const { data } = yield api.getMainListByAreaID(action.payload);
    yield put(actions.setMainListByAreaIDAutonomous(data || undefined));
    yield put(actions.resetMainListByAreaIDAutonomous(data || undefined));
  } catch (error) {
    yield put(actions.setMainListByAreaIDAutonomous(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getSubListById(action) {
  try {
    const { data } = yield api.getSubListById(action.payload);
    yield put(actions.setSubListByIdAutonomous(data || undefined));
    yield put(actions.resetSubListByIdAutonomous(data || undefined));
  } catch (error) {
    yield put(actions.setSubListByIdAutonomous(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* downloadExcelFile(action) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.downloadExcelFile(action.payload);
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    const filename =
      "MOST_AutonomousMaintenanceOrderTasks_" +
      moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") +
      ".xlsx"; //name with date time & extension
    link.setAttribute("download", filename); //or any other extension
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* watchAll() {
  yield takeEvery(
    actions.Types.GET_TASKS_PAGE_FOR_AUTONOMOUS_ORDER_TASKS,
    getTaskList
  );
  yield takeEvery(
    actions.Types.GET_STATUS_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
    getStatusList
  );
  yield takeEvery(
    actions.Types.GET_AREA_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
    getAreaList
  );
  yield takeEvery(actions.Types.GET_EXCEL_FILE, downloadExcelFile);

  yield takeEvery(
    actions.Types.GET_TECHNICIAN_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
    getTechnicianList
  );
  yield takeEvery(
    actions.Types.GET_COST_CENTER_LIST_FOR_AUTONOMOUS_ORDER_TASKS,
    getCostCenterList
  );
  yield takeEvery(
    actions.Types.GET_MAIN_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
    getMainListByAreaIDAutonomous
  );
  yield takeEvery(
    actions.Types.GET_SUB_LIST_BY_AREA_ID_FOR_AUTONOMOUS_ORDER_TASKS,
    getSubListById
  );
}
const AutonomousMaintenanceOrderTaskSaga = [fork(watchAll)];

export default AutonomousMaintenanceOrderTaskSaga;
